export enum RefetchInterval {
  VeryFast = 2_000,
  // 6 seconds
  Fast = 6_000,
  // 10 seconds
  Normal = 10_000,
  // 1 minutes
  Slow = 60_000,
}

export const TOAST_DURATION_MS = 6_000;

export const DEFAULT_CONTENT_WIDTH_DESKTOP = '668px';
export const DEFAULT_PX_MOBILE = '20px';

/**
 * @see https://github.com/chakra-ui/chakra-ui/blob/v2/packages/components/src/transition/transition-utils.ts#L116
 */
export const MODAL_MOTION_SCALE_EXIT_DURATION = 100;
